module.exports = __webpack_public_path__ + "9b818ad46916dc9e4d1577fdfff2d546.png";